import React, { useEffect, useState } from 'react';
import { LegalEntityDto, NaturalPersonDto, PersonDto } from 'api/actor';
import { actorsAPI } from 'services/swagger-api';
import { GenericLoading } from 'components/ui/Loader';
import PersonOverview, { isLegalEntity } from 'features/person-view/components/PersonOverview';

interface PersonOverviewByIdProps {
  personId: string;
}

const PersonOverviewById: React.FC<PersonOverviewByIdProps> = ({ personId }) => {
  const [person, setPerson] = useState<LegalEntityDto | NaturalPersonDto>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPerson = async () => {
      if (!personId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const result = await actorsAPI.getPersonByID({ personId });

        if (result.person) {
          const personData: PersonDto = result.person;
          if (isLegalEntity(personData)) {
            setPerson(personData as LegalEntityDto);
          } else {
            setPerson(personData as NaturalPersonDto);
          }
        } else {
          setError("Aucune personne trouvée.");
        }
      } catch (err) {
        setError('Erreur lors de la récupération des données');
        console.error('Error fetching person:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPerson();
  }, [personId]);

  if (loading) {
    return (
      <div className='relative py-4'>
        <GenericLoading isParentSized loading />
      </div>
    );
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  if (!person) {
    return <div>Aucune donnée disponible</div>;
  }

  return <PersonOverview person={person} />;
};

export default PersonOverviewById;
